import APIClient from '@/shared/http/clients/api'

const resourceName = 'botmaker'
const APICore = process.env.APIBaseURLCore

const GetChatId = (document, config = {}) => APIClient.get(`${APICore}/${resourceName}/chat-id/${document}`, config)

const BotmakerRepository = {
  GetChatId
}

export default BotmakerRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/botmaker/botmaker.js